/* eslint-disable react-hooks/exhaustive-deps */
// SellerNetSheet/hooks/useSellerNetActions.js
import { useCallback } from "react";
import { buildSellerNetPayload } from "../../../../utils/payloadBuilder";
import { generatePdf } from "../../PdfRouteService";
import { saveSellerCalc, updateSellerCalc } from "../services/sellerNetService";
// import { fetchPrintDisclaimerForPdf } from "../../../../utils/disclaimerApi";

export const useSellerNetActions = ({
  user,
  companyId,
  getValues,
  setValue,
  openModal,
  closeModal,
  showToast,
  loadedExistingRef,
  isQuickMode,
  maincompanyid,
  ttbData,
}) => {
  const checkValidSalesPrice = useCallback(() => {
    const salesPrice = getValues("salesPrice");
    const value = Number(String(salesPrice || "").replace(/,/g, ""));
    if (!value) {
      showToast({
        message: "Failure! Please enter a Sales Price",
        type: "error",
      });
      return false;
    }
    return !Number.isNaN(value) && value !== 0;
  }, [getValues, showToast]);

  const handleDownloadPrintPDF = useCallback(
    async (type, calc = "seller") => {
      if (!checkValidSalesPrice()) return;

      const payload = buildSellerNetPayload({
        getVal: getValues,
        user,
        calculatorname: "Seller Net Sheet",
        ttbData,
      });

    //  const printDisclaimer = await fetchPrintDisclaimerForPdf({ maincompanyid, calcSlug: calc, pdfType: "seller", });

      // "print"/"download" vs their "Quick" counterparts open the same
      // window / trigger the same browser download either way — the only
      // difference is isQuickEstimate, which tells the backend to render
      // the property-showcase template (generateSellerPrintEstimate)
      // instead of the regular detailed one. optionType stays a pure
      // tracking label and is intentionally NOT what selects the template
      // (see isSellerPrintEstimate in pdf.controller.js) — there's no
      // dedicated "quick download" tracking counter yet, so that case
      // just tracks as a regular "download".
      const isPrintAction = type === "print" || type === "printQuick";
      const isQuickEstimate = type === "printQuick" || type === "downloadQuick";

      const data = await generatePdf({
        type: "seller",
        calc,
        data: {
          ...payload,
          isQuickMode,
          isQuickEstimate,
          mrsid: getValues("addressMeta")?.mrsid,
          optionType:
            type === "print"
              ? "printdetailedestimate"
              : type === "printQuick"
                ? "printquickestimate"
                : "download",
       //   disclaimer: printDisclaimer,
        },
      });
      const blob = new Blob([data], { type: "application/pdf" });
      const blobUrl = window.URL.createObjectURL(blob);

      if (type === "download" || type === "downloadQuick") {
        const preparedFor = (payload?.preparedfor || "New_Client")
          .replace(/\s+/g, "_")
          .replace(/[^a-zA-Z0-9_]/g, "");
        const timestamp = Math.floor(Date.now() / 1000);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = `Print_for_${preparedFor}_${timestamp}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);
      }

      if (isPrintAction) {
        const win = window.open("", "_blank", "width=900,height=700");
        if (win) {
          win.document.write(`
            <html><head><title>Print PDF</title></head>
            <body style="margin:0;">
              <iframe id="printFrame" src="${blobUrl}" style="width:100%;height:100%;border:none;"></iframe>
              <script>
                const frame = document.getElementById('printFrame');
                frame.onload = function(){ setTimeout(()=>{ frame.contentWindow.focus(); frame.contentWindow.print(); }, 300); };
              </script>
            </body></html>
          `);
          win.document.close();
        }
      }
    },
    [checkValidSalesPrice, getValues, user, maincompanyid, ttbData]
  );

  const handleSave = useCallback(async () => {
    if (!checkValidSalesPrice()) return;

    const payload = buildSellerNetPayload({
      getVal: getValues,
      user,
      payload: { companyId, isQuickMode },
      optionType: "save",
      mrsid: getValues("addressMeta")?.mrsid,

    });

    if (!loadedExistingRef.current) {
      const saved = await saveSellerCalc(payload);
      if (saved) {
        loadedExistingRef.current = saved.calculator.id;
        setValue("id", saved.calculator.id);
        closeModal();
        showToast({
          message: "Seller Calculator saved successfully!",
          type: "success",
        });
      }
      return;
    }

    payload.id = loadedExistingRef.current;
    openModal({
      title: "Warnings",
      size: "mediumsizewidth",
      content: (
        <div className="modelspace application-fe">
          <p className="model-desc-details notice-icon">
            A saved file already exist with same file name, do you want to:
          </p>
          <div className="frm-btn popup-2-btn">
            <button
              className="submit-btn btn-bg inpt-btn"
              onClick={async () => {
                await updateSellerCalc(payload);
                closeModal();
                showToast({
                  message: "Seller Calculator updated successfully!",
                  type: "success",
                });
              }}
            >
              Overwrite Existing
            </button>

            <button
              className="submit-btn btn-bg inpt-btn"
              onClick={async () => {
                loadedExistingRef.current = null;
                closeModal();
                await handleSave();
              }}
            >
              Save as New File
            </button>

            <button
              className="submit-btn btn-bg inpt-btn btn-discard"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </div>
      ),
    });
  }, [
    checkValidSalesPrice,
    getValues,
    user,
    companyId,
    loadedExistingRef,
    setValue,
    openModal,
    closeModal,
    showToast,
  ]);

  return { checkValidSalesPrice, handleSave, handleDownloadPrintPDF };
};
